import NoteInfo from './NoteInfo';

export default NoteInfo;
